import React from "react";
import { Link } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";

/**
 * Collections — /art-dept landing.
 * Three boxes; only the first is active (Tales of Humanity and Technology).
 */
const Collections = () => {
  return (
    <SectionLayout>
      <h2 className="glass-panel__title" data-testid="section-title">
        COLLECTIONS
      </h2>

      <div className="collection-grid" data-testid="collection-grid">
        <Link
          to="/art-dept/tales"
          className="collection-box collection-box--active"
          data-testid="collection-tales"
        >
          <span className="collection-box__index">01</span>
          <span className="collection-box__title">
            Tales of Humanity and Technology
          </span>
        </Link>

        <div
          className="collection-box collection-box--disabled"
          aria-disabled="true"
          data-testid="collection-locked-2"
        >
          <span className="collection-box__index">02</span>
          <span className="collection-box__title collection-box__title--muted">
            —
          </span>
        </div>

        <div
          className="collection-box collection-box--disabled"
          aria-disabled="true"
          data-testid="collection-locked-3"
        >
          <span className="collection-box__index">03</span>
          <span className="collection-box__title collection-box__title--muted">
            —
          </span>
        </div>
      </div>

      <div className="glass-panel__nav">
        <Link to="/" className="glass-panel__btn" data-testid="btn-home">
          Home
        </Link>
      </div>
    </SectionLayout>
  );
};

export default Collections;
